/* eslint-disable class-methods-use-this */

import {nullUrlInterpolator} from '../../../rules/stringTemplateHelpers';
import {isStringOrTemplate} from '../../commons/stringTemplateModel';
import {ClientAtom} from '../expressionAtomModel';
import {buildStringTemplateParameter} from '../expressionParamHelpers';
import {MethodCategoriesEnum, StringMethod} from './internal';

export class Fetcher extends StringMethod {
  constructor() {
    super(MethodCategoriesEnum.SERVER);
  }

  getParameters() {
    return [buildStringTemplateParameter('endpoint')];
  }

  getDefaultName(atom: ClientAtom) {
    const {endpoint} = atom.params;

    if (!isStringOrTemplate(endpoint) || !endpoint) {
      return undefined;
    }

    // The URL can contain variables, but they usually do not influence the host which is what we're interested in here.
    const fakeUrl = nullUrlInterpolator(endpoint);
    if (!fakeUrl) {
      return undefined;
    }

    return fakeUrl.hostname || undefined;
  }
}
